var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_176_37)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 20.1686,
    width: 44,
    height: 44,
    rx: 22,
    fill: "white",
    fillOpacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M42.5 44.6686C43.163 44.6686 43.7989 44.4052 44.2678 43.9363C44.7366 43.4675 45 42.8316 45 42.1686C45 41.5055 44.7366 40.8697 44.2678 40.4008C43.7989 39.932 43.163 39.6686 42.5 39.6686C41.837 39.6686 41.2011 39.932 40.7322 40.4008C40.2634 40.8697 40 41.5055 40 42.1686C40 42.8316 40.2634 43.4675 40.7322 43.9363C41.2011 44.4052 41.837 44.6686 42.5 44.6686V44.6686Z",
    stroke: "#0A0C2B",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1666 42.9027V41.4361C34.1666 40.5694 34.875 39.8527 35.75 39.8527C37.2583 39.8527 37.875 38.7861 37.1166 37.4777C36.6833 36.7277 36.9416 35.7527 37.7 35.3194L39.1416 34.4944C39.8 34.1027 40.65 34.3361 41.0416 34.9944L41.1333 35.1527C41.8833 36.4611 43.1166 36.4611 43.875 35.1527L43.9666 34.9944C44.3583 34.3361 45.2083 34.1027 45.8666 34.4944L47.3083 35.3194C48.0666 35.7527 48.325 36.7277 47.8916 37.4777C47.1333 38.7861 47.75 39.8527 49.2583 39.8527C50.125 39.8527 50.8416 40.5611 50.8416 41.4361V42.9027C50.8416 43.7694 50.1333 44.4861 49.2583 44.4861C47.75 44.4861 47.1333 45.5527 47.8916 46.8611C48.325 47.6194 48.0666 48.5861 47.3083 49.0194L45.8666 49.8444C45.2083 50.2361 44.3583 50.0027 43.9666 49.3444L43.875 49.1861C43.125 47.8777 41.8916 47.8777 41.1333 49.1861L41.0416 49.3444C40.65 50.0027 39.8 50.2361 39.1416 49.8444L37.7 49.0194C37.3367 48.8102 37.0713 48.4655 36.9619 48.0609C36.8526 47.6562 36.9082 47.2247 37.1166 46.8611C37.875 45.5527 37.2583 44.4861 35.75 44.4861C34.875 44.4861 34.1666 43.7694 34.1666 42.9027V42.9027Z",
    stroke: "#0B1775",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_176_37",
    x: 0.5,
    y: 0.168579,
    width: 84,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.886275 0 0 0 0 0.894118 0 0 0 0 0.964706 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_176_37"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_176_37",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.34bc4074112c5a05516e497ebe8f78a8.svg";
export { ForwardRef as ReactComponent };